import {Group, Select, Text, ThemeIcon} from "@mantine/core";
import classes from "./SettingSelectField.module.css";
import {useTranslation} from "react-i18next";
import {useLocalStorage} from "@mantine/hooks";
import IconFast from "../../../../assets/bolt.svg?react";
import IconSparkles from "../../../../assets/sparkles.svg?react";
import {ChatEngine, LocalStorageKeys} from "../../../../types";
import {useAppDispatch} from "../../../../app/hooks";
import {setChatEngine} from "../../sessionSlice";

export function ChatEngineSelectField() {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const [chatEngine, setLocalStorageChatEngine] = useLocalStorage({
        key: LocalStorageKeys.ChatEngine,
        defaultValue: ChatEngine.Standard,
    });

    const handleChatEngineChange = (value: string | null) => {
        if (value) {
            const newChatEngine = value as ChatEngine;
            setLocalStorageChatEngine(newChatEngine);
            dispatch(setChatEngine(newChatEngine));
        }
    };

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>
                {t("settings.chatEngine")}
            </Text>
            <Select
                className={classes.innerItem}
                data={[
                    {
                        value: ChatEngine.Standard,
                        label: t("settings.field.chatEngine.standard"),
                    },
                    {
                        value: ChatEngine.Experimental,
                        label: t("settings.field.chatEngine.experimental"),
                    },
                ]}
                value={chatEngine}
                onChange={handleChatEngineChange}
            />
        </Group>
    );
}
